import { takeLatest, put } from 'redux-saga/effects';
import { fetchOpportunitiesForPropertyHistory, appNotify, setIsFetchingPropertyHistoryOpportunities } from 'store/actions';
import { getWithToken } from 'api/network';

export function* getOpportunitiesForPropertyHistorySaga() {
  yield takeLatest(fetchOpportunitiesForPropertyHistory, function* ({ payload }) {
    const { asgPropId, callback } = payload;
    try {
      yield put(setIsFetchingPropertyHistoryOpportunities(true));
      const res = yield getWithToken(`/api/underwrite/prop/asgPropId/${asgPropId}`);
      const response = yield res.json();
      const opps = response.length > 0 ? response : []; // return empty array if no opps found

      if (callback) {
        yield callback(opps);
      }
    } catch (error) {
      console.log('error', error.message);
      yield put(appNotify(error.message, 'error'));
    }
    finally {
      yield put(setIsFetchingPropertyHistoryOpportunities(false));
    }
  });
}